/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container, NavbarBrand } from "reactstrap";
import { Link } from "react-router-dom";

import './FooterBlack.css'
// core components
import SocialLinks from "components/SocialLinks/SocialLinks.js";

function FooterBlack() {
  return (
    <>
      <footer className="subscribe-line subscribe-line-black" data-background-color="black">
        <Container style={{ width: '100% !important' }} >
          <div className="copyright float-left footer-links">
            <a href="/TerminosCondiciones">
              <h6 className="item-footer-color textot">Términos y condiciones</h6>
            </a>
            <a href="/PoliticasDatosPersonales">
              <h6 className="item-footer-color textot">Política de Tratamiento de Datos Personales</h6>
            </a>
            <a href="/PoliticasDerechosAutor">
              <h6 className="item-footer-color textot">Politícas de derechos de autor</h6>
            </a>
            <a href="/CertificadoAccesibilidad">
              <h6 className="item-footer-color textot">Certificado de Accesibilidad</h6>
            </a>
            <a href="/PoliticasPrivacidadWeb">
              <h6 className="item-footer-color textot">Políticas de Privacidad web</h6>
            </a>
            <a href="/MapaSitio">
              <h6 className="item-footer-color textot">Mapa del Sitio</h6>
            </a>
            <a href="/#contact-us">
              <h6 className="item-footer-color textot">Canal de Atencion al Publico</h6>
            </a>
            <h6 className="item-footer-color textot">Telefono: CEL 317 513 0082</h6>
          </div>
          <div className="copyright position-logo" id="copyright" >
            <NavbarBrand to="/" tag={Link} id="navbar-brand">
              <img style={{ backgroundColor: 'white', borderRadius: '27px' }} src={require("assets/img/LOGO_NOT_10.png")} alt="Logo de la notaría 10 de Bucaramanga" width="110px"></img>
            </NavbarBrand>
          </div>
        </Container>
        <div className="footer-social">
          <SocialLinks />
        </div>
        <div className="div-sinfony">
          <div className="div-sinfony__copyright">
            <h6 style={{ margin: 0, fontSize: 12 }}>© {new Date().getFullYear()}, Designed by{'\u00A0'}</h6>
            <a
              href="https://www.sinfony.com.co/sinfony/"
              target="_blank"
              rel="noreferrer"
              className="item-footer-color"
            >
              <h6 style={{ margin: 0, fontSize: 12 }}>SINFONY Todos los derechos reservados.</h6>
            </a>
          </div>
        </div>
      </footer>
    </>
  );
}

export default FooterBlack;
